export const getters = {
  frontPriceList: ({ frontPriceList }) => frontPriceList,
};
